export const PLACE_ANNOTATION_FETCHED = 'PLACE_ANNOTATION_FETCHED';
export const PLACE_ANNOTATION_REMOVED = 'PLACE_ANNOTATION_REMOVED';
